export const audioApi = {
    autoplayAllowed: navigator.userActivation.hasBeenActive,
    enableAutoplayAction: null,
}

const enableAutoplay = () => {
    audioApi.autoplayAllowed = true;
    if (audioApi.enableAutoplayAction) {
        audioApi.enableAutoplayAction();
    }
}

audioApi.init = () => {
    function enableAudio() {
        enableAutoplay();
        document.removeEventListener('click', enableAudio);
        document.removeEventListener('keydown', enableAudio);
    }
    if (!audioApi.autoplayAllowed) {
        document.addEventListener('click', enableAudio, { once: true });
        document.addEventListener('keydown', enableAudio, { once: true });
    } else {
        enableAutoplay();
    }
}
